import Swiper from '../custom-swiper/custom-swiper';

export default new class aboutClass {
  constructor() {
    this.sliderSelector = '_certificates-slider';
    this.slideSelector = 'certificates__slide';

    this.navigation = {
      nextEl: '.certificates-slider__nav_next',
      prevEl: '.certificates-slider__nav_prev',
      disabledClass: 'certificates-slider__nav_disable',
      hiddenClass: 'certificates-slider__nav_hidden',
    };

    this.pagination = {
      el: '.certificates-slider__pagination',
      lockClass: 'certificates-slider__pagination_disable',
    };

    this.handler();
  }

  handler() {
    const slider = document.querySelector(`.${this.sliderSelector}`);

    if (!slider) return;

    document.addEventListener('DOMContentLoaded', () => {
      this.init(slider);
    });
  }

  init(slider) {
    const { navigation, pagination } = this;
    const slides = slider.querySelectorAll(`.${this.slideSelector}`);

    this.blogSlider = new Swiper(`.${this.sliderSelector}`, {
      slidesPerView: 1,
      spaceBetween: 15,
      breakpointsInverse: true,
      watchOverflow: true,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      observer: true,
      navigation,
      pagination,
      loop: slides.length > 2,
      dots: true,
      breakpoints: {
        468: {
          slidesPerView: 2,
          spaceBetween: 25,
        },
        769: {
          slidesPerView: 4,
          spaceBetween: 25,
        },
      },
    });
  }
}();
